
<footer class="app-footer">
  <div class="footer-inner">
    <div class="footer-brand">
      <strong>{{ 'footer_brand_title' | translate }}</strong>
      <p>{{ 'footer_brand_desc' | translate }}</p>
    </div>

    <div class="footer-col">
      <h5>{{ 'footer_manual_heading' | translate }}</h5>
      <a routerLink="/manuel/introduction">{{ 'introduction' | translate }}</a>
      <a routerLink="/manuel/getting-started">{{ 'getting_started' | translate }}</a>
      <a routerLink="/manuel/glossary">{{ 'glossary' | translate }}</a>
      <a routerLink="/manuel/support">{{ 'support' | translate }}</a>
    </div>

    <div class="footer-col">
      <h5>{{ 'footer_platform_heading' | translate }}</h5>
      <a href="https://youthconnektcameroon.org" target="_blank" rel="noopener">{{ 'footer_official_site' | translate }}</a>
      <a href="https://youthconnektcameroon.org/opportunities" target="_blank" rel="noopener">{{ 'footer_opportunities_link' | translate }}</a>
    </div>
  </div>

  <div class="footer-bottom">
    © {{ year }} {{ 'footer_bottom' | translate }}
  </div>
</footer>
